"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgTicketFiltersClose(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 13"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#17181A",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.157.136l.707.707L.844 12.864l-.708-.707z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.864 12.157l-.707.707L.136.844.843.135z"
  })));
}

var MemoSvgTicketFiltersClose = /*#__PURE__*/React.memo(SvgTicketFiltersClose);
var _default = MemoSvgTicketFiltersClose;
exports["default"] = _default;